// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1O1Ki","Logo":"Toolbar_Logo__7qpld","DeskTopOnly":"Toolbar_DeskTopOnly__1qVv7"};